<template>
  <div>
    <label
        id="switch"
        class="switch"

    >
      <input type="checkbox" v-model="themeStatusMock">
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "ThemeSwitcher",
  computed: {
    ...mapState([
      "themeStatus"
    ]),
    themeStatusMock: {
      get() {
        return this.themeStatus
      },
      set(value) {
        this.changeThemeStatus(value)
      }
    }
  },
  methods: {
    ...mapMutations([
        "changeThemeStatus"
    ]),
  },
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 40px;
  width: 40px;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  box-shadow: 0 0px 3px #2020203d;
  background: white url('https://i.ibb.co/FxzBYR9/night.png') no-repeat center;
}

input:checked + .slider {
  background-color: #26ade4;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(24px);
  -ms-transform: translateX(24px);
  transform: translateX(24px);
  background: white url('https://i.ibb.co/7JfqXxB/sunny.png') no-repeat center;
}

/* Rounded sliders */
.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>